<div class="screen screen--split">

  <app-theme-header></app-theme-header>

  <h1 class="screen__title">Choose Your<br />Payment</h1>

  <div class="screen__stage">

    <ng-container *ngIf="host.paymentTypes.length > 0 && host.commonService.isLoading === false">

      <button type="button" class="method" *ngFor="let type of host.mainPaymentTypes"
        (click)="host.goToPayment(type.code)">
        <span class="method__plate">
          <img class="method__logo" src="assets/img/{{ type.code }}.png" alt="{{ type.name }}" />
        </span>
        <span class="method__name">{{ type.name }}</span>
      </button>

      <ng-container *ngIf="host.subPaymentTypes.length > 0">
        <button type="button" class="text-button" (click)="host.isCollapsed = !host.isCollapsed">
          MORE PAYMENT OPTION
        </button>
        <button type="button" class="method" *ngFor="let type of host.subPaymentTypes"
          [hidden]="host.isCollapsed" (click)="host.goToPayment(type.code)">
          <span class="method__plate">
            <img class="method__logo" src="assets/img/{{ type.code }}.png" alt="{{ type.name }}" />
          </span>
          <span class="method__name">{{ type.name }}</span>
        </button>
      </ng-container>

    </ng-container>

    <div class="screen__notice" *ngIf="host.paymentTypes.length === 0 && host.commonService.isLoading === false">
      No Payment Option Available.<br />Sorry for your inconvenience.
    </div>

  </div>

  <div class="screen__actions">
    <button type="button" class="outline-button" (click)="host.goToPreviousPage()">BACK</button>
  </div>

</div>
